import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export function formatInternationalPhoneNumber(phoneAreaCode: string, localNumber: string): string {
  try {
    const countryCode = phoneAreaCode.startsWith('+') ? phoneAreaCode : `+${phoneAreaCode}`;
    const startsWithAreaCode = localNumber.startsWith(phoneAreaCode) || localNumber.startsWith(`+${phoneAreaCode}`) || localNumber.startsWith('+');

    const fullNumber = startsWithAreaCode ? localNumber : `${countryCode}${localNumber}`;
    const number = phoneUtil.parse(fullNumber);
    
    return phoneUtil.format(number, PhoneNumberFormat.E164);
  } catch (error) {
    console.error('Invalid phone number:', error);
    return ''; 
  }
}

export function extractCountryCodeAndLocalNumber(InternationalPhoneNumber: string) {
  try {
      const number = phoneUtil.parse(InternationalPhoneNumber);
      const countryCode = number.getCountryCode();
      const nationalNumber = number.getNationalNumber();

      return {
          countryCode: `+${countryCode}`,
          localNumber: nationalNumber.toString(),
      };
  } catch (error) {
      console.error('Failed to parse phone number:', error);
      return null;
  }
}

export function removeLeadingZero(phoneNumber: string): string {
  if (phoneNumber.startsWith('0')) {
    return phoneNumber.substring(1);
  }
  return phoneNumber;
}